import { listResearchLibLinks } from 'services/researchLib/listLinks';
import { type ResearchLibLinkT, useAsyncData } from 'utils';

type UseResearchLibLinksResT = {
  items: ResearchLibLinkT[];
  loading: boolean;
};

export default function useResearchLibLinks():
UseResearchLibLinksResT {
  const links = useAsyncData(
    'researchLib.links',
    listResearchLibLinks,
  );

  return {
    items: links.data ?? [],
    loading: links.loading,
  };
}
